<template>
  <div
    class="prfl"
    :style="{
      'background-image': value.backgroundImage.imageURL
        ? 'url(' + value.backgroundImage.imageURL + ')'
        : '',
      'font-family': `'${landingPage.fontName}'`,
    }"
  >
    <div
      v-if="value.people"
      class="performance _1200"
      :style="{
        color: landingPage.textColor,
        'font-family': `'${landingPage.fontName}'`,
      }"
      :class="{
        mni: value.people.length < 3 && !value.backgroundImage.imageURL,
      }"
    >
      <h2
        class="sec-head"
        :style="{ 'font-family': `'${landingPage.fontName}'` }"
      >
        {{ value.title }}
      </h2>
      <div class="pep-box">
        <div
          @click="bio = profile.item.bio"
          v-for="(profile, i) in value.people"
          :key="i"
          class="pep-box mid"
          :class="{
            'super-important': profile.item.superImportant,
            'bio-present': profile.item.bio,
          }"
        >
          <img
            :style="{
              'border-color': landingPage.themeColor,
              zoom: value.logoSize && value.logoSize.value == 'Small' ? 0.8 : 1,
            }"
            class="profile-pic"
            :src="profile.item.profileImage.imageURL"
            :alt="profile.item.name"
            sizes="120px"
          />
          <p
            class="mer-20 bold"
            :style="{ 'font-family': `'${landingPage.fontName}'` }"
          >
            {{ profile.item.name }}
          </p>
          <p class="under-name">{{ profile.item.title }}</p>
          <a
            class="readmore"
            v-if="profile.item.bio"
            :style="{
              'text-decoration-color': landingPage.themeColor,
              color: landingPage.textColor,
            }"
            >Read More ⇢</a
          >
        </div>
      </div>
    </div>
    <popup v-model="bio">
      <div class="bio" v-html="bio"></div>
    </popup>
  </div>
</template>

<script>
export default {
  name: "Profiles",
  props: {
    value: Object,
    landingPage: Object,
  },
  data() {
    return {
      bio: false,
    };
  },
};
</script>

<style scoped>
.pep-box.mid {
  margin-top: 20px;
}
.prfl {
  background-repeat: no-repeat;
  background-size: contain;
}
.super-important {
  display: block;
  margin-bottom: 25px;
}
.super-important .under-name {
  max-width: 300px;
}
.bio {
  /* color: white; */
  width: 90%;
  max-width: 600px;
  border: 1px white solid;
  border-radius: 10px;
  padding: 40px;
  text-align: left;
  background: white;
}

.bio-present {
  cursor: pointer;
}

.bio-present:hover a {
  text-decoration: underline;
}
</style>